import React, {Component} from 'react';
import StaffTranslationViewContent from './StaffTranslationViewContent';

class StaffTranslationView extends Component {

    getSiteName = (options) => {
        let siteId = this.props.staffTranslation.site_id;

        let name = options.find(element => {
            return siteId === element.id ? siteId : ''
        });

        name = name ? name.display_name : '';
        return name;
    }
    
    render() {
        return (
            this.props.loading !== true && this.props.staffTranslation &&
            <StaffTranslationViewContent
                staffMember={this.props.staffMember}
                staffTranslation={this.props.staffTranslation}
                siteName={this.getSiteName(this.props.sites)}
                classes={this.props.classes}
            />
        )
    }
}

export default StaffTranslationView;



// WEBPACK FOOTER //
// ./src/containers/staff/translations/StaffTranslationView.jsx